<template>
  <!--  -->
  <button class="export-midi-button" @click="exportMIDI" :disabled="chordProgression.length === 0">
    <i class="fa-solid fa-cloud-arrow-down"></i> Export as MIDI
  </button>
</template>

  
<script>
import { Midi } from '@tonejs/midi';

export default {
  name: 'MidiExporter',
  props: {
    chordProgression: Array,
  },
  data() {
    return {
      chords: [
        { id: '1', name: 'C Major', notes: ['C4', 'E4', 'G4'] },
        { id: '2', name: 'D Minor', notes: ['D4', 'F4', 'A4'] },
        { id: '3', name: 'E Minor', notes: ['E4', 'G4', 'B4'] },
        { id: '4', name: 'F Major', notes: ['F4', 'A4', 'C5'] },
        { id: '5', name: 'G Major', notes: ['G4', 'B4', 'D4'] },
        { id: '6', name: 'A Minor', notes: ['A4', 'C5', 'E4'] },
        { id: '7', name: 'B Diminished', notes: ['B4', 'D4', 'F4'] },
        { id: '27', name: 'D Minor 7', notes: ['D4', 'F4', 'A4', 'C5'] },
        { id: '47', name: 'F Major 7', notes: ['F4', 'A4', 'C5', 'E4'] },
        { id: '67', name: 'A Minor 7', notes: ['A4', 'C5', 'E4', 'G4'] },
        { id: '16', name: 'C Major 6', notes: ['C4', 'E4', 'G4', 'A4'] },
        { id: '57', name: 'Gm7', notes: ['G4', 'Bb4', 'D4', 'F4'] },
        { id: '37', name: 'Em7', notes: ['E4', 'G4', 'B4', 'D4'] },
        { id: '17', name: 'Am7', notes: ['C4', 'E4', 'G4', 'B4'] },
        { id: 'b57', name: 'Gdom7', notes: ['G4', 'B4', 'D4', 'F4'] },
        { id: '564', name: 'V64', notes: ['D4', 'G4', 'B4'] },
        { id: '164', name: 'I64', notes: ['G4', 'C5', 'E4'] },
        { id: '26', name: 'ii6', notes: ['F4', 'A4', 'D5'] },
        { id: '56/5', name: 'V6/V', notes: ['Gb4', 'A4', 'D5'] },
        { id: '7/5', name: 'vii°/V', notes: ['Gb4', 'A4', 'C5'] },
        { id: '46', name: 'IV6', notes: ['A4', 'C5', 'F5'] },
        { id: '665', name: 'vi65', notes: ['A4', 'C5', 'E4', 'G4'] },
        { id: '664', name: 'vi64', notes: ['E4', 'A4', 'C5'] },
        { id: '542', name: 'V42', notes: ['F4', 'G4', 'B4', 'D5'] },
        { id: '56', name: 'V6', notes: ['G4', 'B4', 'D5', 'E5'] },
        { id: '365', name: 'iii65', notes: ['G4', 'B4', 'E5'] },
      ],
    };
  },
  methods: {
    exportMIDI() {
      const midi = new Midi();
      const track = midi.addTrack();

      // Check if chordProgression is defined and is an array
      if (Array.isArray(this.chordProgression)) {
        this.chordProgression.forEach((chordID, index) => {
          const chord = this.chords.find(c => c.id === chordID);
          if (chord) {
            chord.notes.forEach((noteName) => {
              track.addNote({
                midi: this.noteToMidi(noteName),
                time: index * 1, // For simplicity, place each chord at 1-second intervals
                duration: 1 // Example: each chord lasts for 1 second
              });
            });
          }
        });
      } else {
        console.error('chordProgression is not an array or is undefined');
        return;
      }

      // Serialize MIDI and trigger download
      // This is browser-specific code; it will not work in Node.js environments
      const url = URL.createObjectURL(new Blob([midi.toArray()], { type: "audio/midi" }));


      // Create a link to download the file
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = 'chordProgression.mid';
      downloadLink.click();
    },
    noteToMidi(noteName) {
      const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
      const octave = parseInt(noteName.slice(-1), 10);
      const note = noteName.slice(0, -1);
      const index = notes.indexOf(note);
      return index + 12 * (octave + 1);
    }
  }
}
</script>
  